import { ArrowLeft, Loader2 } from 'lucide-react';
import { BusinessDetailsSection } from '../AddClientPage/sections/BusinessDetailsSection';
import { ContactPersonSection } from '../AddClientPage/sections/ContactPersonSection';
import { ClientAddressSection } from '../AddClientPage/sections/ClientAddressSection';
import { AuthorizationLetterSection } from '../AddClientPage/sections/AuthorizationLetterSection';
import { useEditClientForm } from './useEditClientForm';

export default function EditClientPage() {
  const {
    id,
    navigate,
    mobileConfig,
    register,
    control,
    setValue,
    watch,
    setError,
    clearErrors,
    errors,
    handleSubmit,
    isLoading,
    isSaving,
    isNotFound,
    authorizationLetterFileName,
    authorizationLetterError,
    isUploadingAuthorizationLetter,
    onSelectAuthorizationLetter,
    clearAuthorizationLetter,
  } = useEditClientForm();

  if (isLoading) {
    return (
      <div className="flex justify-center py-24">
        <Loader2 className="h-6 w-6 animate-spin text-[var(--dash-brand)]" />
      </div>
    );
  }

  if (isNotFound) {
    return (
      <div className="mx-auto flex w-full max-w-3xl flex-col gap-4 py-10 text-left">
        <p className="m-0 text-sm text-[var(--dash-muted)]">Client not found.</p>
        <button
          type="button"
          onClick={() => navigate('/clients')}
          className="inline-flex w-fit items-center gap-1.5 text-sm font-medium text-[var(--dash-brand)]"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to clients
        </button>
      </div>
    );
  }

  return (
    <div className="flex w-full flex-col gap-3">
      <button
        type="button"
        onClick={() => navigate(id ? `/clients/${id}` : '/clients')}
        className="inline-flex w-fit items-center gap-1.5 text-sm font-medium text-[var(--dash-muted)] transition hover:text-[var(--dash-ink)]"
      >
        <ArrowLeft className="h-4 w-4" />
        Back
      </button>

      <header className="camp-fade-up text-left">
        {/* <p className="m-0 text-[11px] font-semibold tracking-[0.12em] text-[var(--dash-brand)] uppercase">
          Clients
        </p> */}
        <h1 className="m-0 mt-0.5 text-xl font-semibold tracking-tight text-[var(--dash-ink)] sm:text-2xl">
          Edit Client
        </h1>
        <p className="mt-0.5 mb-0 text-sm text-[var(--dash-muted)]">
          Update business and contact details
        </p>
      </header>

      <form
        onSubmit={handleSubmit}
        className="camp-fade-up flex flex-col gap-3"
        style={{ animationDelay: '60ms' }}
      >
        <BusinessDetailsSection
          register={register}
          errors={errors}
          watch={watch}
          setValue={setValue}
        />

        <ContactPersonSection
          register={register}
          control={control}
          errors={errors}
          mobileConfig={mobileConfig}
          setError={setError}
          clearErrors={clearErrors}
          emailReadOnly
        />

        <ClientAddressSection register={register} errors={errors} />

        <AuthorizationLetterSection
          fileName={authorizationLetterFileName}
          isUploading={isUploadingAuthorizationLetter}
          error={authorizationLetterError}
          onSelect={onSelectAuthorizationLetter}
          onClear={clearAuthorizationLetter}
        />

        <div className="sticky bottom-3 z-10 flex flex-col-reverse gap-3 rounded-2xl border border-[var(--dash-line)] bg-white/95 p-3 shadow-[0_12px_32px_-18px_rgba(16,38,73,0.45)] backdrop-blur sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={() => navigate(id ? `/clients/${id}` : '/clients')}
            className="h-11 rounded-xl px-5 text-sm font-semibold text-[var(--dash-muted)] transition hover:bg-[var(--dash-soft)] hover:text-[var(--dash-ink)]"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={isSaving || isUploadingAuthorizationLetter}
            className="dash-btn-gradient inline-flex h-11 items-center justify-center gap-2 rounded-xl px-6 text-sm font-semibold text-white disabled:opacity-50"
          >
            {isSaving ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
            Save Changes
          </button>
        </div>
      </form>
    </div>
  );
}
